import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const BankService = {

  getAllBank: async () => {
    try {
      const response = await axios.get(ENDPOINT.bank);
      return response.data;
    } catch (error) {
      console.error("Error fetching bank:", error.message);
      throw error;
    }
  },

  createBank: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.bank, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching bank:", error.message);
      throw error;
    }
  },

  updateBank: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.bank}/${id}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching bank:", error.message);
      throw error;
    }
  },

  deleteBank: async ( id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.bank}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching bank:", error.message);
      throw error;
    }
  },

};
